import styled from 'styled-components'

export const ContainerCarouselListItem = styled.div`
  width: 100%;
  padding-left: 24px;
`
